import styled from 'styled-components/native'

export const ViewNotifyAndMe = styled.View`
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
`
